export const configuration = {
  termsLink: "https://upwex.io/terms-of-use/",
  privacyPolicyLink: "https://upwex.io/privacy-policy/",
  apiKey:
    "SIlehjJOZbqrjFV9tZijqa81xEXbQFxZHYYGBY6FJ9vzj1sbmfgEm0HblHyUb0R8GaueiurAXuRP1rL0OGwG5XOddBAVUw22k0EIQ",
  bApiKey: "ZlCFtTEt1EhGYH1PCvX87fH4ChihXio3",
};
